<div id="widerrufsbelehrung" class=" content">

    <h2 *ngIf="title" class="mt-6">Widerrufsbelehrung für Verbraucher</h2>


    <p><strong>Widerrufsrecht</strong><br>
        Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt,
        die überwiegend weder ihrer gewerblichen noch ihrer selbstständigen beruflichen Tätigkeit zugerechnet werden können.</p>

    <p>Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.</p>

    <p>Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag:</p>
    <ul>
        <li>an dem Sie oder ein von Ihnen benannter Dritter, der nicht Beförderer ist, die Waren in Besitz genommen haben, sofern Sie eine oder mehrere Waren im Rahmen einer einheitlichen Bestellung bestellt haben und diese einheitlich geliefert werden;</li>
        <li>an dem Sie oder ein von Ihnen benannter Dritter die letzte Ware in Besitz genommen haben, sofern Sie mehrere Waren im Rahmen einer einheitlichen Bestellung bestellt haben und diese getrennt geliefert werden;</li>
        <li>an dem Sie oder ein von Ihnen benannter Dritter die letzte Teilsendung oder das letzte Stück in Besitz genommen haben, sofern Sie eine Ware bestellt haben, die in mehreren Teilsendungen oder Stücken geliefert wird.</li>
    </ul>

    <p>Um Ihr Widerrufsrecht auszuüben, müssen Sie uns:</p>
    <p>
        {{getCompany()}}
    </p>

    <p>mittels einer eindeutigen Erklärung (z.B. Brief oder E-Mail) über Ihren Entschluss informieren, diesen Vertrag zu widerrufen.
        Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.</p>

    <p>Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung vor Ablauf der Widerrufsfrist absenden.</p>

    <h2 class="title is-4">Folgen des Widerrufs</h2>
    <p>
        Wenn Sie diesen Vertrag widerrufen, erstatten wir Ihnen alle Zahlungen einschließlich Lieferkosten
        (ausgenommen zusätzliche Kosten durch abweichende Lieferarten) unverzüglich und spätestens binnen 14 Tagen nach Eingang Ihres Widerrufs.
        Die Rückzahlung erfolgt über dasselbe Zahlungsmittel wie bei der ursprünglichen Transaktion, es sei denn, es wurde ausdrücklich etwas anderes vereinbart.
    </p>
    <p>
        Wir können die Rückzahlung verweigern, bis wir die Waren zurückerhalten haben oder Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben – je nachdem, welches der frühere Zeitpunkt ist.
    </p>
    <p>
        Sie haben die Waren spätestens binnen 14 Tagen ab Widerruf an uns zurückzugeben oder zu übergeben. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf absenden.
        Sie tragen die unmittelbaren Kosten der Rücksendung.
    </p>
    <p>
        Für einen etwaigen Wertverlust der Waren müssen Sie nur aufkommen, wenn dieser auf einen nicht notwendigen Umgang mit ihnen zurückzuführen ist.
    </p>

    <h2 class="title is-4">Ausschluss bzw. vorzeitiges Erlöschen des Widerrufsrechts</h2>
    <p>Das Widerrufsrecht besteht nicht bei Verträgen:</p>
    <ul>
        <li>zur Lieferung individuell gefertigter oder personalisierter Waren;</li>
        <li>zur Lieferung verderblicher Waren oder Waren mit kurzem Verfallsdatum;</li>
        <li>zur Lieferung versiegelter Waren, wenn die Versiegelung nach Lieferung entfernt wurde und diese aus Hygienegründen nicht rückgabefähig sind;</li>
        <li>zur Lieferung von Waren, die nach Lieferung untrennbar mit anderen Gütern vermischt wurden.</li>
    </ul>

    <h2 class="title is-4">Muster-Widerrufsformular</h2>
    <p>(Wenn Sie den Vertrag widerrufen wollen, füllen Sie bitte dieses Formular aus und senden Sie es zurück.)</p>
    <pre>
An: {{getCompany()}}

        Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über den Kauf der folgenden Waren / die Erbringung der folgenden Dienstleistung:

Bestellt am: ___________ / erhalten am: ___________

Name des Verbrauchers: ___________________________

Anschrift: ________________________________________

Unterschrift (nur bei Mitteilung auf Papier):

Datum: ___________
    </pre>


</div>
